import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import ownerIntelligenceService from '@/services/ownerIntelligence.service';

export function useOwnerCommandCenter() {
  return useQuery({
    queryKey: ['owner-intelligence', 'command-center'],
    queryFn: () => ownerIntelligenceService.getCommandCenter(),
    staleTime: 60000,
  });
}

export function useOwnerGroupDashboard() {
  return useQuery({
    queryKey: ['owner-intelligence', 'group-dashboard'],
    queryFn: () => ownerIntelligenceService.getGroupDashboard(),
    staleTime: 60000,
  });
}

export function useOwnerBusinessHealth() {
  return useQuery({
    queryKey: ['owner-intelligence', 'business-health'],
    queryFn: () => ownerIntelligenceService.getBusinessHealth(),
    staleTime: 60000,
  });
}

export function useOwnerKpiSnapshots(periodType?: string) {
  return useQuery({
    queryKey: ['owner-intelligence', 'kpi-snapshots', periodType],
    queryFn: () => ownerIntelligenceService.listKpiSnapshots(periodType),
    staleTime: 120000,
  });
}

export function useOwnerDataQuality() {
  return useQuery({
    queryKey: ['owner-intelligence', 'data-quality'],
    queryFn: () => ownerIntelligenceService.getDataQuality(),
    staleTime: 120000,
  });
}

export function useOwnerGrowthProfit() {
  return useQuery({ queryKey: ['owner-intelligence', 'growth-profit'], queryFn: () => ownerIntelligenceService.getGrowthProfit() });
}

export function useOwnerFinancialHealth(years = 2) {
  return useQuery({
    queryKey: ['owner-intelligence', 'financial-health', years],
    queryFn: () => ownerIntelligenceService.getFinancialHealth(years),
    staleTime: 120000,
  });
}

export function useOwnerCash() {
  return useQuery({ queryKey: ['owner-intelligence', 'cash'], queryFn: () => ownerIntelligenceService.getCash() });
}

export function useOwnerCustomers() {
  return useQuery({ queryKey: ['owner-intelligence', 'customers'], queryFn: () => ownerIntelligenceService.getCustomers() });
}

export function useOwnerOperations() {
  return useQuery({ queryKey: ['owner-intelligence', 'operations'], queryFn: () => ownerIntelligenceService.getOperations() });
}

export function useOwnerSupplyChain() {
  return useQuery({ queryKey: ['owner-intelligence', 'supply-chain'], queryFn: () => ownerIntelligenceService.getSupplyChain() });
}

export function useOwnerRisk() {
  return useQuery({ queryKey: ['owner-intelligence', 'risk'], queryFn: () => ownerIntelligenceService.getRisk() });
}

export function useRefreshOwnerSnapshots() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => ownerIntelligenceService.refreshSnapshots(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['owner-intelligence'] });
    },
  });
}
